import { useTranslation } from "../context/TranslationContext";
import { platformById, PlatformLogo } from "./campaign/shared";
import Button from "./ds/Button";
import Modal from "./ds/Modal";
import TextField from "./ds/TextField";

const PLACEHOLDERS = {
  youtube: "https://youtube.com/@yourchannel",
  instagram: "https://instagram.com/username",
  facebook: "https://facebook.com/username",
  tiktok: "https://tiktok.com/@username",
};

const SocialModal = ({ socialModal, setSocialModal, tempSocialUrl, setTempSocialUrl, handleSocialChange, isDark }) => {
  const { t } = useTranslation();
  if (!socialModal) return null;

  const close = () => {
    setSocialModal(null);
    setTempSocialUrl("");
  };

  const save = (value) => {
    handleSocialChange(socialModal)({ target: { value } });
    close();
  };

  return (
    <Modal
      open
      onClose={close}
      title={platformById(socialModal)?.name || socialModal}
      closeLabel={t("common.close")}
      media={<PlatformLogo platform={socialModal} size={24} className="mt-[2px]" />}
      isDark={isDark}
    >
      <TextField
        label={t("mintSpace.socialLinkLabel")}
        placeholder={PLACEHOLDERS[socialModal]}
        value={tempSocialUrl}
        onChange={(e) => setTempSocialUrl(e.target.value)}
        autoFocus
      />
      <div className="flex justify-end gap-space-12">
        <Button variant="gray" onClick={() => save("")}>
          {t("common.remove")}
        </Button>
        <Button onClick={() => save(tempSocialUrl)}>
          {t("common.save")}
        </Button>
      </div>
    </Modal>
  );
};

export default SocialModal;
